import Title from "common/Typography/Title";
import Flex from "common/Boxes/Flex";
import React from "react";
import styled from "styled-components";
import { CircleCheck } from "lucide-react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface FreeTagProps {
  isFree?: boolean;
}

const FreeTag = ({ isFree }: FreeTagProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  return (
    <Flex $justifyContent="flex-start">
      <FreeCheck size={16} strokeWidth={2} aria-hidden />
      <StyledTitle level={5}>
        {isFree ? t("free_tag.free_group") : t("free_tag.free_trial")}
      </StyledTitle>
    </Flex>
  );
};

export default FreeTag;

const StyledTitle = styled(Title)`
  position: relative;
  top: 1px;
`;
const FreeCheck = styled(CircleCheck)`
  flex-shrink: 0;
  color: ${(p) => p.theme.colors.green};
  margin-right: 6px;
`;
